/**
 * 자막 정렬 방향의 사용자 설정 — 호스트·뷰어 **독립**으로 기억한다.
 *
 * 저장소는 localStorage 다(세션이 아니라 이 브라우저의 취향이므로).
 * 프라이빗 모드 등으로 저장이 막혀도 화면은 정상 동작해야 한다 — 실패는
 * 조용히 무시하고 메모리 상태로만 산다.
 */

import { useCallback, useState } from 'react'
import {
  DEFAULT_ORDER,
  isFeedOrder,
  orderStorageKey,
  type FeedOrder,
} from './feed-order'

export function useFeedOrder(role: 'host' | 'viewer'): {
  order: FeedOrder
  setOrder: (order: FeedOrder) => void
  toggle: () => void
} {
  const [order, setOrderState] = useState<FeedOrder>(() => {
    if (typeof localStorage === 'undefined') return DEFAULT_ORDER
    try {
      const raw = localStorage.getItem(orderStorageKey(role))
      return isFeedOrder(raw) ? raw : DEFAULT_ORDER
    } catch {
      return DEFAULT_ORDER
    }
  })

  const setOrder = useCallback(
    (next: FeedOrder) => {
      setOrderState(next)
      try {
        localStorage.setItem(orderStorageKey(role), next)
      } catch {
        // 저장 실패는 무시한다 — 정렬은 이번 세션만 유지된다.
      }
    },
    [role],
  )

  const toggle = useCallback(() => {
    setOrder(order === 'newest-first' ? 'newest-last' : 'newest-first')
  }, [order, setOrder])

  return { order, setOrder, toggle }
}
